<template>
  <div 
    class="fill-height mt-2">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>

            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="dialog.confirm"
            @keydown.esc="dialog.confirm = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Konfirmasi Update Status

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin ingin mengubah status menjadi {{ selected.status }}?
              </v-card-text>

              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>

              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  rounded
                  width="120"
                  @click="statuses()"
                  :loading="process.status"
                  :disabled="process.status"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Ubah
                </v-btn>

                <v-btn
                  rounded
                  width="120"
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-card 
            flat
            style="border-radius: 10px;">
            <v-card-text class="pa-1">
              <v-row
                class="pa-4 pb-1">
                <v-col 
                  cols="12"
                  class="py-0">
                  <v-card 
                    flat
                    height="calc(100vh - 275px)"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <v-row>
                            <v-col cols="6" class="py-0">
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Nomor Penawaran
                                </div>
                                {{ form.tender_number }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false">
                                <ValidationProvider 
                                  name="Nomor Penawaran" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Nomor Penawaran
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
              
                                    :color="set_color"
                                    placeholder="Nomor Penawaran"
              
                                    hide-details
              
                                    v-model="form.tender_number"
                                    :success="form.tender_number !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.tender_number !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                            </v-col>
                            <v-col cols="6" class="py-0">
                              <div class="black_one mb-4 fs-14" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true">
                                <div class="mb-2 font_weight_600 fs-13 black_one">
            
                                  Tanggal Penawaran
                                </div>
                                {{ form.tender_date | date }}
                              </div>
                              <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false">
                                <ValidationProvider 
                                  name="Tanggal Penawaran" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="mb-2 font_weight_600 fs-13 black_one">
                                    <span class="red--text">*</span>
              
                                    Tanggal Penawaran
                                  </div>
              
                                  <v-text-field
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
              
                                    :color="set_color"
                                    placeholder="Tanggal Penawaran"
              
                                    hide-details
                                    type="date"
              
                                    v-model="form.tender_date"
                                    :success="form.tender_date !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    class="mb-6"
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
              
                                      <div v-if="form.tender_date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                              <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                                Dokumen Penawaran
                              </div> 
                              <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3" v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false">
                                <div class="mr-3">
                                  <uploadimage
                                    v-model="upload.image" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="#4B4B4B"
                                        elevation="0"
                                        small
                                        :disabled="process.image || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                                        :loading="process.image"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                        <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah Gambar
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploadimage>
                                </div>
                                <div class="mr-3">
                                  <uploadfile
                                    v-model="upload.document" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="primary"
                                        elevation="0"
                                        small
                                        :disabled="process.document || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                                        :loading="process.document"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600;">
                                        <v-icon size="15">mdi-file-document</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah File
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploadfile>
                                </div>
                              </div>
  
                              <div class="">
                                <table style="border: 1px solid #ededed; width: 100%;">
                                  <tr>
                                    <th v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Aksi
                                    </th>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Link
                                    </th>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      Nama Dokumen Penawaran
                                    </th>
                                  </tr>
                                  <!-- <tr v-for="(item, index) in form.request_image" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="form.request_image.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="indigo"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-image-area</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <ValidationProvider 
                                        :name="`Nama Dokumen ${index + 1}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2 font_weight_600 fs-13 black_one">
                                          <span class="red--text">*</span>
                    
                                          Nama Dokumen
                                        </div>
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Nama Dokumen"
                    
                                          hide-details
                    
                                          v-model="item.title"
                                          :success="item.title !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          class="mb-0"
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.title !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </td>
                                  </tr>
                                  <tr v-for="(item, index) in form.request_file" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="form.request_file.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <ValidationProvider 
                                        :name="`Nama Dokumen ${index + 1}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2 font_weight_600 fs-13 black_one">
                                          <span class="red--text">*</span>
                    
                                          Nama Dokumen
                                        </div>
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Nama Dokumen"
                    
                                          hide-details
                    
                                          v-model="item.title"
                                          :success="item.title !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          class="mb-0"
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.title !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </td>
                                  </tr> -->
  
                                  <tr v-for="(item, index) in all_document" :key="index">
                                    <td v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="all_document.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                          </v-btn>
                                        </template>
  
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true">
                                        {{ item.title }}
                                      </div>
                                      <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false">
                                        <ValidationProvider 
                                          :name="`Nama Dokumen Penawaran ${index + 1}`" 
                                          rules="required" 
                                          v-slot="{ errors, valid }">
                                          <div class="mb-2 font_weight_600 fs-13 black_one">
                                            <span class="red--text">*</span>
                      
                                            Nama Dokumen Penawaran
                                          </div>
                      
                                          <v-text-field
                                            v-on:keydown.enter.prevent="save()"
                                            
                                            filled
                                            rounded
                                            dense
                                            :readonly="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                      
                                            :color="set_color"
                                            placeholder="Nama Dokumen Penawaran"
                      
                                            hide-details
                      
                                            v-model="item.title"
                                            :success="item.title !== '' && valid"
                                            :error-messages="errors"
                                            required
                                            class="mb-0"
                                            style="border-radius: 10px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
                      
                                              <div v-if="item.title !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
  
                              <v-card-text
                                v-if="all_document.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data Data Dokumen Penawaran
                                  </div>
                                </div>
                              </v-card-text>
  
                            </v-col> 
                          </v-row>
                        </v-form>
                      </ValidationObserver>
  
  
                      <div v-if="message.error.length > 0"
                        class="text-left d-flex align-center mr-3">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
  
              <v-row
                justify="end"
                :class="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? 'pa-5' : 'pa-4 py-0' : 'pa-5'">
                <v-col 
                  cols="12"
                  md="8">
                  <div v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? false : true : false">
                    <v-btn
                      @click="selected.status = 'Persiapan'; dialog.confirm = true"
                      :disabled="process.status || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                      elevation="0"
                      rounded
                      v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false"
                      style="border-radius: 6px; font-weight: 600;"
                      color="#FFA000"
                      class="fs-14 white--text text-capitalize">
                      <v-icon
                        size="20">
                        mdi-update
                      </v-icon>
    
                      <span
                        class="ml-2">
                        Update ke Persiapan
                      </span>
                    </v-btn>
                    <v-btn
                      @click="selected.status = 'Negosiasi'; dialog.confirm = true"
                      :disabled="process.status || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                      elevation="0"
                      rounded
                      v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false"
                      style="border-radius: 6px; font-weight: 600;"
                      color="indigo"
                      class="fs-14 white--text text-capitalize ml-2">
                      <v-icon
                        size="20">
                        mdi-update
                      </v-icon>
    
                      <span
                        class="ml-2">
                        Update ke Negosiasi
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col 
                  cols="12"
                  md="4"
                  class="d-flex align-center justify-end py-0">
                  <v-btn
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? false : true : false : true"
                    elevation="0"
                    rounded
                    v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Penawaran' ? detail_project.administrasi_bool ? true :false : true : false"
                    style="border-radius: 6px; font-weight: 600;"
                    color="success"
                    class="fs-14 white--text text-capitalize">
                    <v-icon
                      size="20">
                      mdi-checkbox-marked-circle-outline
                    </v-icon>
  
                    <span
                      class="ml-2">
                      Simpan
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        unit: [],
        detail_project: {},
        dialog: {
          snackbar: false,
          confirm: false,
          fullscreen: false
        },
        form: {
          id: '',
          tender_number: '',
          tender_date: '',
          request_file_object: [],
          request_file: [],
          request_image: [],
          type_file: 'image'
        },
        filename: [],
        upload: {
          image: null,
          document: null
        },
        selected: {
          status: '',
          confirm: [],
          delete: []
        },
        all_document: [],
        client: [],
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,
          status: false,
          image: false,
          document: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.request_image.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })
              this.all_document.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image'
              })

              this.upload.image = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.filename.push(this.upload.document.filename)
              this.form.request_file.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })
              this.all_document.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1]
              })

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`project/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_project = res.results.data
            this.filename = []
            this.form.id = res.results.data.id
            this.form.tender_number = res.results.data.tender_number
            this.form.tender_date = res.results.data.tender_date === null ||  res.results.data.tender_date === '' ? new Date().toISOString().substr(0, 10) : res.results.data.tender_date
            this.form.request_file = Object.keys(res.results.data.tender_file_object).length > 0 ? res.results.data.tender_file_object.doc : []
            this.form.request_image = Object.keys(res.results.data.tender_file_object).length > 0 ? res.results.data.tender_file_object.image : []
            // this.filename = res.results.data.tender_file_object.doc.map(item => item.url.split('/').pop())
            this.all_document = []

            if (Object.keys(res.results.data.tender_file_object).length > 0) {
              this.all_document.push(
                ...res.results.data.tender_file_object.image.map(item => {
                  return {
                    title: item.title,
                    url: item.url,
                    type: item.type
                  }
                })
              )
            }
            if (Object.keys(res.results.data.tender_file_object).length > 0) {
              this.all_document.push(
                ...res.results.data.tender_file_object.doc.map(item => {
                  return {
                    title: item.title,
                    url: item.url,
                    type: item.type
                  }
                })
              )
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        this.form.request_file = this.all_document.filter(item => item.type !== 'image')
        this.form.request_image = this.all_document.filter(item => item.type === 'image')

        const isValid = await this.$refs.form.validate(),
              isDocument = this.form.request_file.length > 0 || this.form.request_image.length > 0
        this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Dokumen Penawaran harus diisi' : ''
        if (isValid && isDocument) {
          this.process.form = true

          // SAVE TO REST API
          await post(`project/tender`, {
            data: {
              id: this.form.id,
              tender_number: this.form.tender_number,
              tender_date: this.form.tender_date,
              tender_file_object: {
                "doc": this.form.request_file,
                "image": this.form.request_image
              }
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
              // if (this.form.id === '') {
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async statuses () {
        this.message.error = ''
        this.process.status = true

        // SAVE TO REST API
        await post(`project/status`, {
          data: {
            id: this.$route.params.id,
            status: this.selected.status
          }
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.dialog.confirm = false
            this.dialog.fullscreen = false
            this.message.success = res.message
            if (this.selected.status === 'Persiapan') {
              this.$router.push(`/project/process/persiapan/${this.form.id}?step=internal`)
            } else {
              this.$router.push(`/project/process/negosiasi/${this.form.id}`)
            }
            this.$emit('reloaddata')

          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 250px); 
} 
.wrapper th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>